import React, {
  Component,
  // createRef
} from "react";
import Product from "../productsList/Product";

import { connect } from "react-redux";
import Cookies from "universal-cookie";
import {
  InputGroup,
  Input,
  // Button,
  // Label,
  // Row,
  // Col,
} from "reactstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faTimes,
//   // faFilter,
//   faArrowUp
// } from "@fortawesome/free-solid-svg-icons";

import "../../assets/css/custom.css";
import { serverResponse } from "../../util/fakeServer";
import withParams from "../common/WithParams";
import withLocation from "../common/WithLocation";
import { gaEventLabel } from "../../settings/gaConfig";
import { isIE, isEdge } from "react-device-detect";
import { styles } from "./categories.styles";
import Adsense from "../leaflet/Adsense";
import { language } from "../../languageProvider/language/language";
import {
  defaultLanguage,
  getCustomActions,
  getProductInteractivityTypes,
  iconsObj,
  INTERACTIVITY_TYPE_TO_LABEL_KEY,
  isProductOnSale,
  sendAnalyticsEvent,
} from "../..//helper/utility";
// import Select from "react-select";
import { getPricesAction } from "../../redux/price/price.action";
// import searchPageLogo from "../../assets/images/searchpagelogo.png";
import { BREAKPOINT } from "../../helper/constant";
import "../../assets/css/categorystatic.css";
// import { Link } from "react-router-dom";
// import BackArrowIcon from "../../assets/icons/backarrow-icon";
import { Search } from "../../assets/images/icone";
// import ManagerFactory from "../../managers/ManagerFactory";
import { openInteractivityModal } from "../../redux/modal/action";
import CategoryChipsRow from "./mobile/CategoryChipsRow";
import ProductsGridGrouped from "./mobile/ProductsGridGrouped";
import FiltersBottomSheet from "./mobile/FiltersBottomSheet";
import ActiveFiltersRow from "./mobile/ActiveFiltersRow";

// Compute readable text color on top of a hex background.
function getContrastTextColor(hexColor) {
  if (!hexColor || typeof hexColor !== "string") return "#ffffff";
  const c = hexColor.replace("#", "");
  if (c.length !== 6) return "#ffffff";
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  if (isNaN(r) || isNaN(g) || isNaN(b)) return "#ffffff";
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? "#1f1f23" : "#ffffff";
}

// const manager = ManagerFactory.getManager();

const DEFAULT_ITEMS = 12;

const checkAllCategoriesHaveLogo = (categories) => {
  return categories.every(category => category.category_logo && category.category_logo.trim() !== '');
};

if (
  serverResponse.config.only_browsable ||
  serverResponse.config.hide_product_page
) {
  var path = window.location.pathname;
  if (path === "/categories") {
    window.location.href = "/leaflet";
  }
}

const openBanner = () => {
  if (serverResponse.config.internal_banner_click) {
    var id_prod_special = serverResponse.config.product_banner;
    if (document.getElementById("plus-" + id_prod_special)) {
      sendAnalyticsEvent(gaEventLabel.banner_click, String(id_prod_special));
      document.getElementById("plus-" + id_prod_special).click();
    }
  } else if (serverResponse.config.external_banner_click) {
    window.open(serverResponse.config.href_banner, "_blank");
  }
};

class CategoriesStatic extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.selectCategoryRef = React.createRef();
    this.selectSubCategoryRef = React.createRef();

    let page_has_video = false;
    let video_only_once = false;
    let video_mandatory_seconds = 0;
    let videos = [];
    let video_never = false;

    if (serverResponse.hasOwnProperty("video_categories")) {
      page_has_video = true;
      videos = serverResponse.video_categories.videos.map((i) => i.page);
      video_only_once = serverResponse.video_categories.show_only_once;
      video_mandatory_seconds =
        serverResponse.video_categories.mandatory_seconds;
    }

    const cookies = new Cookies();

    if (cookies.get("neverTutorial") !== undefined) video_never = true;

    // Pre-compute products grouped by category name and the list of
    // categories that actually contain at least one product (server order).
    const allProducts = Object.values(serverResponse.interactivities).filter(
      (el) => el.type === "product"
    );
    const productsByCategory = {};
    allProducts.forEach((p) => {
      const key = p.category || "";
      if (!productsByCategory[key]) productsByCategory[key] = [];
      productsByCategory[key].push(p);
    });
    this.productsByCategory = productsByCategory;

    const serverCategories =
      (serverResponse.leaflet && serverResponse.leaflet.categories) || [];
    this.allCategoriesMobile = serverCategories
      .filter(
        (c) =>
          productsByCategory[c.category_name] &&
          productsByCategory[c.category_name].length > 0
      )
      .map((c) => ({
        id: c.id,
        name: c.category_name,
        logo: c.category_logo || null,
      }));

    // Pre-compute unique brand list once (mobile bottom-sheet filter). Each
    // entry carries the first non-empty brand_logo we find for that brand.
    {
      const seenBrands = new Map();
      allProducts.forEach((p) => {
        if (!p || !p.brand) return;
        if (!seenBrands.has(p.brand)) {
          seenBrands.set(p.brand, p.brand_logo || null);
        } else if (!seenBrands.get(p.brand) && p.brand_logo) {
          seenBrands.set(p.brand, p.brand_logo);
        }
      });
      this.brandsList = Array.from(seenBrands.entries()).map(
        ([name, logo]) => ({ name, logo })
      );
    }

    // Show the "Offerte" chip only if at least one product qualifies as
    // on-sale; otherwise the chip would always yield zero results.
    this.hasAnyOnSale = allProducts.some(isProductOnSale);

    // Build the list of interactivity marker types present in the leaflet
    // (excluding "plus" which every product carries). Each entry has a stable
    // count of products that own at least one marker of that type.
    {
      const typeCount = new Map();
      allProducts.forEach((p) => {
        const types = getProductInteractivityTypes(p);
        types.forEach((t) => typeCount.set(t, (typeCount.get(t) || 0) + 1));
      });
      this.interactivityTypes = Array.from(typeCount.entries())
        .map(([type, count]) => ({ type, count }))
        .sort((a, b) => b.count - a.count);
    }

    // Tenant-level feature flags (publication.json -> client.config). Missing
    // keys default to false for backward compatibility with legacy flyers.
    // A filter is rendered only when its flag is true AND the leaflet actually
    // has matching data — avoids showing an empty section.
    const cfg = serverResponse.config || {};
    this.showOnSaleFilter =
      cfg.show_on_sale_filter === true && this.hasAnyOnSale;
    this.showInteractivityFilter =
      cfg.show_interactivity_filter === true &&
      this.interactivityTypes.length > 0;

    this.state = {
      products: allProducts,
      tags:
        serverResponse.leaflet && serverResponse.leaflet.tags
          ? Object.values(serverResponse.leaflet.tags)
          : [],
      promos:
        serverResponse.leaflet && serverResponse.leaflet.attributes?.promo
          ? Object.keys(serverResponse.leaflet.attributes.promo).map(
              (promoId) => {
                const promo = serverResponse.leaflet.attributes.promo[promoId];
                const childId = promo.children
                  ? Object.keys(promo.children)[0]
                  : null;

                return {
                  id: childId ? promo.children[childId].id : promo.id,
                  nome: childId ? promo.children[childId].nome : promo.nome,
                  img: childId ? promo.children[childId].img : promo.img,
                };
              }
            )
          : [],
      nameFilter: "",
      brandFilter: false,
      underpriceFilter: false,
      onSaleFilter: false,
      selectedInteractivities: new Set(),
      accordionOpen: { tag: false, promo: false, interactivity: false },
      categoryFilter: "",
      subCategoryFilter: "",
      items: 0,
      hasMoreItems: true,
      showScrollUp: false,
      page_has_video: page_has_video,
      videos: videos,
      show_close_video: false,
      preroll_video_in_progress: false,
      video_only_once: video_only_once,
      video_page_number: null,
      video_page_item_id: null,
      countdown: video_mandatory_seconds,
      video_mandatory_seconds: video_mandatory_seconds,
      video_modal_open: false,
      video_url: "",
      video_muted: true,
      video_playing: false,
      video_never: video_never,
      loading: false,
      numberOfItem: null,
      sidebarFilterOpen: false,
      listType: "grid",
      subCategoryArr: [],
      itemsToRender: [],
      skulsArr: [],
      totalProduct: 0,
      globalHeigth: window.innerHeight,
      globalWidth: window.innerWidth,
      isFirstTime: true,
      itemsRender: false,
      selectedTags: new Set(),
      selectedPromos: new Set(),
      selectedBrands: new Set(),
      bottomSheetOpen: false,
      tagsItemRender: false,
      promoItemRender: false,
      activeChevronCategory: null,
      arrowButtonClick: false,
      activeCategory: null,
      showSubCategories: false,
      categoryLogo: "",
      shouldShowLogos: false,
      // Step 4: mobile sticky stack auto-hide on scroll down.
      stickyRowHidden: false,
    };

    // Step 4: instance fields (not state) for scroll bookkeeping & debounce.
    this._lastScrollY = 0;
    this._scrollRaf = null;
    this._saveDebounce = null;
    this._onScroll = null;
  }

  backToCategories = () => {
    this.setState({
      showSubCategories: false,
      activeCategory: null,
    });
  };

  handleTagClick = (tagId) => {
    this.setState((prevState) => {
      const newSelectedTags = new Set(prevState.selectedTags);
      if (newSelectedTags.has(tagId)) {
        newSelectedTags.delete(tagId);
      } else {
        newSelectedTags.add(tagId);
      }

      // Check if any filters are active
      const hasTagFilters = newSelectedTags.size > 0;
      const hasPromoFilters = prevState.selectedPromos.size > 0;
      const hasCategoryFilters = prevState.categoryFilter || prevState.subCategoryFilter;

      // Determine which view to show
      let showTagsOrPromos = hasTagFilters || hasPromoFilters;
      let showCategoryItems = !hasTagFilters && !hasPromoFilters && hasCategoryFilters;

      return {
        selectedTags: newSelectedTags,
        tagsItemRender: showTagsOrPromos,
        promoItemRender: false, // Will be handled by tagsItemRender when combined
        itemsRender: showCategoryItems,
      };
    });
    this.setState({ sidebarFilterOpen: false, nameFilter: "" });
  };

  handlePromoClick = (promoId) => {
    this.setState((prevState) => {
      const newSelectedPromos = new Set(prevState.selectedPromos);

      if (newSelectedPromos.has(promoId)) {
        newSelectedPromos.delete(promoId);
      } else {
        newSelectedPromos.add(promoId);
      }

      // Check if any filters are active
      const hasTagFilters = prevState.selectedTags.size > 0;
      const hasPromoFilters = newSelectedPromos.size > 0;
      const hasCategoryFilters = prevState.categoryFilter || prevState.subCategoryFilter;

      // Determine which view to show
      let showTagsOrPromos = hasTagFilters || hasPromoFilters;
      let showCategoryItems = !hasTagFilters && !hasPromoFilters && hasCategoryFilters;

      return {
        selectedPromos: newSelectedPromos,
        tagsItemRender: showTagsOrPromos,
        promoItemRender: false, // Will be handled by tagsItemRender when combined
        itemsRender: showCategoryItems,
        // Don't reset category filters unless promo is selected
        categoryFilter: hasPromoFilters ? "" : prevState.categoryFilter,
        subCategoryFilter: hasPromoFilters ? "" : prevState.subCategoryFilter,
      };
    });

    this.setState({ nameFilter: "" });
  };

  cancelTagsFilter = () => {
    this.setState({
      nameFilter: "",
      brandFilter: false,
      underpriceFilter: false,
      onSaleFilter: false,
      items: DEFAULT_ITEMS,
      hasMoreItems: true,
      tagsItemRender: false,
      promoItemRender: false,
      selectedPromos: new Set(),
      selectedTags: new Set(),
      selectedBrands: new Set(),
      selectedInteractivities: new Set(),
      categoryFilter: "",
      subCategoryFilter: "",
      itemsRender: false,
      activeChevronCategory: null,
    });
  };

  getCategoryName(categoryId) {
    const categoriesArray = Object.values(
      serverResponse.interactivities
    ).filter((el) => el.type === "product");
    
    const category = categoriesArray.find(
      (cat) => +cat.category_id === +categoryId
    );
    
    return category ? category.category : "N/D";
  }

  getCategoryLogo(categoryId) {
    const categoriesArray = Object.values(serverResponse.leaflet.categories);
    const categoryLogo = categoriesArray.find((cat) => cat.id === categoryId);

    return categoryLogo ? categoryLogo.category_logo : null;
  }

  openBanner = () => {
    const { config, interactivities } = serverResponse;

    // Gestione clic banner interno
    if (config.internal_banner_click && config.product_banner) {
      const interact = interactivities[config.product_banner];

      if (interact) {
        const info = getCustomActions().getInteractivity(config.product_banner);

        if (info) {
          this.props.openInteractivityModal(
            { info, type: "plus" },
            config.product_banner
          );
        }
      }

      return; // Uscita anticipata se non esiste interactivity
    }

    // Gestione clic banner esterno
    if (config.external_banner_click && config.href_banner) {
      let href = config.href_banner;

      // Se href non contiene "http://" o "https://", aggiungilo manualmente
      if (!/^https?:\/\//i.test(href)) {
        href = `https://${href}`;
      }

      window.open(href, "_blank");
    }
  };

  /**
   * Parse the URL search string and apply ?q= / ?cat= filters. Triggered by
   * componentDidMount and by componentDidUpdate when location.search changes
   * (e.g. when the user runs a search from the mobile header).
   *
   * If both `q` and `cat` are empty/absent, no state is changed (user-applied
   * filters are preserved).
   */
  applyUrlQuery = () => {
    const search =
      (this.props.location && this.props.location.search) ||
      window.location.search ||
      "";
    if (!search) return;
    let params;
    try {
      params = new URLSearchParams(search);
    } catch (_e) {
      return;
    }
    const q = (params.get("q") || "").trim();
    const cat = (params.get("cat") || "").trim();
    if (!q && !cat) return;

    if (q) {
      // Run the same flow as a textual search: drive the flat results view.
      this.setState(
        {
          nameFilter: q,
          isFirstTime: false,
          items: 0,
          itemsRender: true,
          itemsToRender: [],
          categoryFilter: "",
          subCategoryFilter: "",
          selectedTags: new Set(),
          selectedPromos: new Set(),
          selectedBrands: new Set(),
          activeChevronCategory: null,
          showSubCategories: false,
        },
        () => this.updateProducts()
      );
      const inputEl = document.getElementById("product_");
      if (inputEl) inputEl.value = q;
      return;
    }

    if (cat) {
      const match = (serverResponse.leaflet?.categories || []).find(
        (c) => c.category_name === cat
      );
      if (match) {
        this.handleChangeCategoryMobile(
          match.category_name,
          match.category_logo
        );
      }
    }
  };

  componentDidMount() {
    window.addEventListener("resize", this.resize);
    if (this.props.params.name !== undefined) {
      this.setState({ nameFilter: this.props.match.params.name });
    }

    // Inizializza shouldShowLogos
    this.setState({
      shouldShowLogos: checkAllCategoriesHaveLogo(serverResponse.leaflet.categories)
    });

    const scrollTarget =
      this.state.globalWidth >= BREAKPOINT.xs
        ? document.querySelector(".wrapper_vm_container").parentNode
        : document.querySelector("#scrollable-div");

    // Step 4: composite scroll handler — keeps existing infinite scroll
    // trigger (trackScrolling) and adds rAF-throttled auto-hide for the
    // mobile sticky stack.
    this._onScroll = () => {
      this.trackScrolling();
      if (this._scrollRaf == null) {
        this._scrollRaf = window.requestAnimationFrame(
          this.handleStickyAutoHide
        );
      }
    };
    scrollTarget.addEventListener("scroll", this._onScroll, { passive: true });

    // if (serverResponse.config.ga_active) {
    //   ReactGA.pageview(
    //     `/${serverResponse.config.client_id}-${serverResponse.leaflet.id}/categorie`
    //   );
    // }

    if (this.state.page_has_video && !this.state.video_never) {
      this.showPageVideo(-1, true);
    }
    if (this.props.params.item_id !== undefined) {
      if (document.getElementById("plus-" + this.props.match.params.item_id))
        document
          .getElementById("plus-" + this.props.match.params.item_id)
          .click();
    }
    if (this.props.params.item_id !== undefined) {
      this.setState({ items: this.state.products.length });
    }

    // Set --primary-contrast CSS var (used by mobile chip styles).
    try {
      const primary =
        serverResponse.config && serverResponse.config.primary_color;
      if (primary) {
        document.documentElement.style.setProperty(
          "--primary-contrast",
          getContrastTextColor(primary)
        );
      }
    } catch (e) {
      /* no-op */
    }

    // Step 4: housekeeping — drop sessionStorage entries from other leaflets.
    try {
      for (let i = sessionStorage.length - 1; i >= 0; i--) {
        const k = sessionStorage.key(i);
        if (
          k &&
          k.startsWith("pf:filters:") &&
          k !== this.getStorageKey()
        ) {
          sessionStorage.removeItem(k);
        }
      }
    } catch (e) {
      /* no-op */
    }

    // Initial load: show grouped grid by default (no filters).
    this.setState(
      {
        items: DEFAULT_ITEMS,
        isFirstTime: false,
      },
      () => {
        this.updateProducts();
        // Step 4: try to restore session filters BEFORE honouring URL deep
        // links — URL params take precedence over the persisted state.
        const search = window.location.search || "";
        const hasUrlQuery =
          search && (search.includes("q=") || search.includes("cat="));
        if (!hasUrlQuery) {
          this.restoreFiltersFromSession();
        }
        // Honour ?q= / ?cat= deep links coming from the mobile header search.
        this.applyUrlQuery();
      }
    );

    // Controlla l'altezza del contenuto dopo il mount iniziale
    setTimeout(() => {
      this.checkContentHeight();
    }, 500);
  }

  componentDidUpdate(prevProps, prevState) {
    const prevSearch =
      (prevProps && prevProps.location && prevProps.location.search) || "";
    const currSearch =
      (this.props && this.props.location && this.props.location.search) || "";
    if (prevSearch !== currSearch) {
      this.applyUrlQuery();
    }

    // Step 4: persist filter state to sessionStorage (debounced) whenever a
    // user-visible filter changes.
    if (prevState) {
      const prevInter =
        prevState.selectedInteractivities || new Set();
      const curInter = this.state.selectedInteractivities || new Set();
      const changed =
        prevState.categoryFilter !== this.state.categoryFilter ||
        prevState.selectedTags.size !== this.state.selectedTags.size ||
        prevState.selectedPromos.size !== this.state.selectedPromos.size ||
        prevState.selectedBrands.size !== this.state.selectedBrands.size ||
        prevState.nameFilter !== this.state.nameFilter ||
        prevState.onSaleFilter !== this.state.onSaleFilter ||
        prevInter.size !== curInter.size;
      if (changed) {
        if (this._saveDebounce) clearTimeout(this._saveDebounce);
        this._saveDebounce = setTimeout(
          () => this.saveFiltersToSession(),
          200
        );
      }
    }
  }

  componentWillUnmount() {
    const scrollTarget =
      this.state.globalWidth >= BREAKPOINT.xs
        ? document.querySelector(".wrapper_vm_container").parentNode
        : document.querySelector("#scrollable-div");
    if (scrollTarget && this._onScroll) {
      scrollTarget.removeEventListener("scroll", this._onScroll);
    }
    if (this._saveDebounce) {
      clearTimeout(this._saveDebounce);
      this._saveDebounce = null;
    }
    if (this._scrollRaf != null) {
      window.cancelAnimationFrame(this._scrollRaf);
      this._scrollRaf = null;
    }
  }

  resize = () => {
    this.setState({
      globalHeigth: window.innerHeight,
    });
    this.setState({ globalWidth: window.innerWidth }, () => {
      // Controlla il contenuto dopo il resize
      if (this.state.itemsToRender.length > 0) {
        setTimeout(() => {
          this.checkContentHeight();
        }, 300);
      }
    });
  };

  handleTextualSearch = () => {
    if (this.state.nameFilter.length > 2) {
      this.setState(
        {
          isFirstTime: false,
          items: 0,
          itemsRender: true,
          itemsToRender: [],
          categoryFilter: "",
          subCategoryFilter: "",
          selectedTags: new Set(),
          selectedPromos: new Set(),
          selectedBrands: new Set(),
          activeChevronCategory: null,
          showSubCategories: false,
        },
        () => this.updateProducts()
      );
      // setTimeout(() => {
      //   // document.getElementById("scroller").scrollIntoView();
      //   if (this.myRef && this.myRef.current) {
      //     //  this.myRef.current.scrollIntoView({ behavior: "smooth" });
      //   }
      // }, 0);
    }
  };

  handleChangeName = (e) => {
    const newSearchValue = e.target.value;
    const trimmedFilter = newSearchValue.replace(/\s/g, "");
    this.setState(
      {
        nameFilter: newSearchValue,
        items: [],
        hasMoreItems: true,
      },
      () => {
        if (trimmedFilter.length === 0) {
          this.cancelTagsFilter();
        } else if (trimmedFilter.length <= 2) {
          setTimeout(() => {
            if (isIE || isEdge) {
              document.getElementById("scrollable-div").scrollTop = 0;
            } else {
              document.getElementById("scrollable-div").scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
              });
            }
            if (this.myRef && this.myRef.current) {
              this.myRef.current.scrollIntoView({ behavior: "smooth" });
            }
          }, 0);
        } else {
          this.handleTextualSearch();
        }
      }
    );
  };

  handleChangeBrand = (e) => {
    this.setState({
      brandFilter: e.target.checked,
      items: [],
      hasMoreItems: true,
    });
    document.getElementById("scrollable-div").scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  handleChangeCategory = (value, logo) => {
    this.setState(
      {
        categoryFilter: value,
        categoryLogo: logo,
        subCategoryFilter: "",
        subCategoryArr: serverResponse.leaflet.categories.find(
          (e) => e.category_name === value
        ).subcategories,
        items: DEFAULT_ITEMS,
        hasMoreItems: true,
      },
      () => {
        !this.state.arrowButtonClick &&
          this.handleSearch() &&
          this.setState({ nameFilter: "" });
      }
    );

    // this.myRef.current.scrollTo(0, 0);
    setTimeout(() => {
      if (isIE || isEdge) {
        document.getElementById("scrollable-div").scrollTop = 0;
      } else {
        document.getElementById("scrollable-div").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }

      if (this.myRef && this.myRef.current) {
        this.myRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
  };

  handleChangeCategoryMobile = (value, logo) => {
    this.setState(
      {
        categoryFilter: value,
        categoryLogo: logo,
        subCategoryFilter: "",
        subCategoryArr: serverResponse.leaflet.categories.filter(
          (e) => e.category_name === value
        )[0].subcategories,
        items: DEFAULT_ITEMS,
        hasMoreItems: true,
        // showSubCategories: true,
      },
      () => {
        !this.state.arrowButtonClick &&
          this.handleSearch() &&
          this.setState({ nameFilter: "" });
      }
    );
  };

  handleChangeSubCategory = (value) => {
    this.setState(
      {
        subCategoryFilter: value,
        items: DEFAULT_ITEMS,
        hasMoreItems: true,
        nameFilter: "",
      },
      () => this.handleSearch()
    );
    setTimeout(() => {
      if (this.myRef && this.myRef.current) {
        this.myRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
  };
  handleChangeSubCategoryMobile = (value) => {
    this.setState(
      {
        subCategoryFilter: value,
        items: DEFAULT_ITEMS,
        hasMoreItems: true,
        nameFilter: "",
      },
      () => this.handleSearch()
    );
    // this.myRef.current.scrollTo(0, 0);
    setTimeout(() => {
      if (isIE || isEdge) {
        document.getElementById("scrollable-div").scrollTop = 0;
      } else {
        document.getElementById("scrollable-div").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
    }, 0);
  };

  productFilter = (product) => {
    let nameCheck = false;
    let categoryCheck = false;
    let subcategoryCheck = false;
    // if (product.skul) {
    nameCheck = String(product.description)
      .toLowerCase()
      .includes(this.state.nameFilter.toLowerCase())
      ? true
      : false;

    categoryCheck =
      this.state.categoryFilter !== ""
        ? product.category?.toLowerCase() ===
          this.state.categoryFilter.toLowerCase()
          ? true
          : false
        : true;
    subcategoryCheck =
      this.state.subCategoryFilter !== ""
        ? product.subcategory?.toLowerCase() ===
          this.state.subCategoryFilter.toLowerCase()
          ? true
          : false
        : true;
    const tagCheck =
      this.state.selectedTags.size > 0
        ? product.tags?.some((tag) => this.state.selectedTags.has(tag))
        : true;

    const promoCheck =
      this.state.selectedPromos.size > 0
        ? Object.entries(product.attributes?.promo || {}).some(
            ([parentId, childId]) => {
              return (
                this.state.selectedPromos.has(Number(parentId)) ||
                (childId && this.state.selectedPromos.has(childId))
              );
            }
          )
        : true;
    const brandCheck =
      this.state.selectedBrands && this.state.selectedBrands.size > 0
        ? this.state.selectedBrands.has(product.brand)
        : true;
    const onSaleCheck = this.state.onSaleFilter
      ? isProductOnSale(product)
      : true;
    const interSet = this.state.selectedInteractivities;
    let interCheck = true;
    if (interSet && interSet.size > 0) {
      const productTypes = getProductInteractivityTypes(product);
      interCheck = false;
      // OR within group: product matches if it owns any of the selected types.
      for (const t of interSet) {
        if (productTypes.has(t)) {
          interCheck = true;
          break;
        }
      }
    }
    // }
    return (
      nameCheck &&
      categoryCheck &&
      subcategoryCheck &&
      tagCheck &&
      promoCheck &&
      brandCheck &&
      onSaleCheck &&
      interCheck
    );
  };

  resetFilters = () => {
    this.setState(
      {
        nameFilter: "",
        brandFilter: false,
        underpriceFilter: false,
        onSaleFilter: false,
        categoryFilter: "",
        categoryLogo: "",
        subCategoryFilter: "",
        subCategoryArr: [],
        items: 0,
        hasMoreItems: true,
        skulsArr: [],
        itemsToRender: [],
        isFirstTime: false,
        activeChevronCategory: null,
        itemsRender: false,
        promoItemRender: false,
        selectedPromos: new Set(),
        selectedTags: new Set(),
        selectedBrands: new Set(),
        selectedInteractivities: new Set(),
        tagsItemRender: false,
      },
      () => this.updateProducts()
    );
    // Reset the search input field too — its value isn't controlled.
    try {
      const el = document.getElementById("product_");
      if (el) el.value = "";
    } catch (_e) {
      /* no-op */
    }

    if (this.selectCategoryRef.current) this.selectCategoryRef.current.clearValue();
    if (this.selectSubCategoryRef.current) this.selectSubCategoryRef.current.clearValue();

    // document.getElementById("scrollable-div").scrollTop = 0;
    setTimeout(() => {
      this.myRef.current.scrollIntoView({ behavior: "smooth" });
    }, 0);
  };

  resetFiltersMobile = () => {
    this.closeFilterBar();
    this.setState(
      {
        nameFilter: "",
        brandFilter: false,
        underpriceFilter: false,
        categoryFilter: "",
        subCategoryFilter: "",
        items: 0,
        hasMoreItems: true,
        itemsRender: false,
        selectedTags: new Set(),
        selectedPromos: new Set(),
        selectedBrands: new Set(),
        tagsItemRender: false,
        promoItemRender: false,
        activeChevronCategory: null,
        isFirstTime: false,
      },
      () => this.updateProducts()
    );

    const inputEl = document.getElementById("product_");
    if (inputEl) inputEl.value = "";

    setTimeout(() => {
      this.myRef.current.scrollIntoView({ behavior: "smooth" });
    }, 0);
    if (isIE || isEdge) {
      document.getElementById("scrollable-div").scrollTop = 0;
    } else {
      document.getElementById("scrollable-div").scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  formatCat = (obj) => {
    let opt = [];
    obj.arr.map((element) =>
      opt.push({
        value: obj.key ? element[obj.key] : element,
        label: obj.key ? element[obj.key] : element,
      })
    );
    return opt;
  };

  handleSearch = () => {
    if (
      this.state.categoryFilter !== "" ||
      this.state.subCategoryFilter !== "" ||
      this.state.nameFilter.replace(/\s/g, "") !== ""
    )
      this.setState(
        {
          isFirstTime: false,
          items: 0,
          itemsToRender: [],
          nameFilter: "",
        },
        () => this.updateProducts()
      );
    this.setState({ itemsRender: true });
  };

  updateProducts = () => {
    this.setState(
      {
        items: this.state.items + DEFAULT_ITEMS,
      },
      () => {
        let filteredProducts = this.state.products
          .filter((el) => !el.dynamic_info)
          .filter((i) => i.markers.filter((m) => m.type === "plus").length > 0)
          .filter((el) => el.skul !== undefined)
          .filter(this.productFilter);

        this.setState(
          {
            totalProduct: filteredProducts.length,
            itemsToRender: filteredProducts.slice(0, this.state.items),
            sidebarFilterOpen: false,
          },
          () => {
            this.retrieveSkuls(this.state.itemsToRender);
            // Controlla se il contenuto è sufficiente per riempire l'altezza disponibile
            setTimeout(() => {
              this.checkContentHeight();
            }, 200);
          }
        );
      }
    );
  };

  retrieveSkuls = (arr, cb) => {
    let startFrom = this.state.skulsArr.length;
    this.setState(
      {
        skulsArr: arr.filter((el) => el.dynamic_price).map((el) => el.skul),
      },
      () => {
        //REDUX

        this.props.getPricesAction(
          "",
          false,
          this.state.skulsArr.slice(startFrom, this.state.skulsArr.length)
        );
      }
    );
  };

  classChangeClick(categoryName) {
    const isSame = this.state.activeChevronCategory === categoryName;
    if (isSame) {
      return;
    }
    this.setState((prevState) => ({
      activeChevronCategory:
        prevState.activeChevronCategory === categoryName ? null : categoryName,
    }));
  }

  isBottom(el) {
    return el.scrollHeight - el.scrollTop - el.clientHeight < 1;
  }

  // Controlla se il contenuto è sufficiente per riempire l'altezza disponibile
  checkContentHeight = () => {
    const scrollTarget =
      this.state.globalWidth >= BREAKPOINT.xs
        ? document.querySelector(".wrapper_vm_container").parentNode
        : document.querySelector("#scrollable-div");

    if (scrollTarget) {
      const hasScrollbar = scrollTarget.scrollHeight > scrollTarget.clientHeight;
      
      // Se non c'è scrollbar e ci sono ancora prodotti da caricare, carica automaticamente
      if (!hasScrollbar && this.state.itemsToRender.length < this.state.totalProduct && this.state.itemsToRender.length > 0) {
        setTimeout(() => {
          this.updateProducts();
        }, 100);
      }
    }
  };

  trackScrolling = () => {
    const scrollTarget =
      this.state.globalWidth >= BREAKPOINT.xs
        ? document.querySelector(".wrapper_vm_container").parentNode
        : document.querySelector("#scrollable-div");

    if (scrollTarget && this.isBottom(scrollTarget)) {
      if (this.state.itemsToRender.length < this.state.totalProduct) {
        this.updateProducts();
      }
      // Non rimuovere l'event listener, potrebbe servire ancora
    }
  };

  closeFilterBar = () => {
    this.setState({
      categoryFilter: "",
      sidebarFilterOpen: false,
    });
  };

  // ---- Mobile chips + grouped grid helpers ----

  handleSelectCategoryChip = (name) => {
    if (name === null || name === undefined || name === "") {
      // "Tutti" -> reset selection but keep view in grouped mode.
      this.setState(
        {
          categoryFilter: "",
          subCategoryFilter: "",
          subCategoryArr: [],
          categoryLogo: "",
          activeChevronCategory: null,
          items: 0,
          itemsToRender: [],
          itemsRender: false,
          tagsItemRender: false,
          promoItemRender: false,
          isFirstTime: false,
        },
        () => this.updateProducts()
      );
      return;
    }
    const cat = (this.allCategoriesMobile || []).find((c) => c.name === name);
    this.handleChangeCategoryMobile(name, cat ? cat.logo : "");
  };

  handleFilterButtonClick = () => {
    // Step 2: open the new bottom-sheet filter UI (Tag / Promo / Marchi).
    this.setState({ bottomSheetOpen: true });
  };

  handleCloseBottomSheet = () => {
    this.setState({ bottomSheetOpen: false });
  };

  /**
   * Apply tag/promo/brand filters chosen from the bottom-sheet. We honour the
   * AND-with-category, AND-with-name, OR-within-group rules through the
   * existing productFilter() logic (plus the new brand check).
   */
  handleApplyFilters = ({ tags, promos, brands, onSale, interactivities }) => {
    const nextTags = tags instanceof Set ? tags : new Set(tags || []);
    const nextPromos = promos instanceof Set ? promos : new Set(promos || []);
    const nextBrands = brands instanceof Set ? brands : new Set(brands || []);
    const nextOnSale = Boolean(onSale);
    const nextInter =
      interactivities instanceof Set
        ? interactivities
        : new Set(interactivities || []);

    const anyExtraFilter =
      nextTags.size > 0 ||
      nextPromos.size > 0 ||
      nextBrands.size > 0 ||
      nextOnSale ||
      nextInter.size > 0;
    const hasCategory =
      this.state.categoryFilter || this.state.subCategoryFilter;

    this.setState(
      {
        selectedTags: nextTags,
        selectedPromos: nextPromos,
        selectedBrands: nextBrands,
        selectedInteractivities: nextInter,
        onSaleFilter: nextOnSale,
        bottomSheetOpen: false,
        items: 0,
        itemsToRender: [],
        // Drive the desktop conditional renderers so tag/promo/brand filters
        // produce the flat list view (instead of the grouped category view).
        tagsItemRender: anyExtraFilter,
        promoItemRender: false,
        itemsRender: !anyExtraFilter && Boolean(hasCategory),
        isFirstTime: false,
      },
      () => this.updateProducts()
    );
  };

  /**
   * Build the ordered group list for the mobile grouped grid based on the
   * current filter state. nameFilter is honoured.
   *
   * Returns: [{ categoryName, categoryLogo, products }]
   */
  // Compute live counters per category and sub-category, applying every
  // currently-active filter EXCEPT the category/subcategory dimension.
  // Used by the desktop sidebar to show "(N)" next to each entry.
  getCategoryCounts = () => {
    const {
      nameFilter,
      selectedTags,
      selectedPromos,
      selectedBrands,
      onSaleFilter,
      selectedInteractivities,
    } = this.state;

    const nf = (nameFilter || "").trim().toLowerCase();
    const useName = nf.length > 2;
    const tagSet = selectedTags || new Set();
    const promoSet = selectedPromos || new Set();
    const brandSet = selectedBrands || new Set();
    const interSet = selectedInteractivities || new Set();

    const matchAllNonCategory = (p) => {
      if (useName) {
        const desc = String(p.description || "").toLowerCase();
        if (!desc.includes(nf)) return false;
      }
      if (tagSet.size > 0) {
        if (!Array.isArray(p.tags) || !p.tags.some((t) => tagSet.has(t)))
          return false;
      }
      if (promoSet.size > 0) {
        const promoMap = p.attributes && p.attributes.promo;
        if (!promoMap) return false;
        const ok = Object.entries(promoMap).some(([parentId, childId]) => {
          if (promoSet.has(Number(parentId))) return true;
          if (childId && promoSet.has(childId)) return true;
          return false;
        });
        if (!ok) return false;
      }
      if (brandSet.size > 0 && !brandSet.has(p.brand)) return false;
      if (onSaleFilter && !isProductOnSale(p)) return false;
      if (interSet.size > 0) {
        const types = getProductInteractivityTypes(p);
        let ok = false;
        for (const t of interSet) {
          if (types.has(t)) {
            ok = true;
            break;
          }
        }
        if (!ok) return false;
      }
      return true;
    };

    const products = (this.state.products || []).filter(matchAllNonCategory);
    const total = products.length;
    const byCategory = new Map(); // catName -> { total, subs: Map<subName, n> }
    products.forEach((p) => {
      const cat = p.category || "";
      const sub = p.subcategory || "";
      if (!byCategory.has(cat)) byCategory.set(cat, { total: 0, subs: new Map() });
      const entry = byCategory.get(cat);
      entry.total += 1;
      if (sub) entry.subs.set(sub, (entry.subs.get(sub) || 0) + 1);
    });
    return { total, byCategory };
  };

  // Compute live counts for tag / promo / interactivity entries shown in the
  // desktop sidebar. Each count = "products that would match if I selected
  // ONLY this entry in its group, keeping the currently-active filters in
  // the OTHER groups (cat, name, brand, onSale, + the other 2 multi-select
  // groups). Each group gets its own base set with itself excluded."
  getDynamicFilterCounts = () => {
    const products = (this.state.products || []).filter(
      (el) =>
        !el.dynamic_info &&
        el.markers &&
        el.markers.filter((m) => m.type === "plus").length > 0 &&
        el.skul !== undefined
    );

    const {
      nameFilter,
      categoryFilter,
      subCategoryFilter,
      selectedTags,
      selectedPromos,
      selectedBrands,
      selectedInteractivities,
      onSaleFilter,
    } = this.state;

    const nf = (nameFilter || "").trim().toLowerCase();
    const useName = nf.length > 0;
    const catLower = (categoryFilter || "").toLowerCase();
    const subLower = (subCategoryFilter || "").toLowerCase();
    const tagSet = selectedTags || new Set();
    const promoSet = selectedPromos || new Set();
    const brandSet = selectedBrands || new Set();
    const interSet = selectedInteractivities || new Set();

    const passCategoryNameBrandSale = (p) => {
      if (catLower && (p.category || "").toLowerCase() !== catLower)
        return false;
      if (
        subLower &&
        (p.subcategory || "").toLowerCase() !== subLower
      )
        return false;
      if (useName) {
        const desc = String(p.description || "").toLowerCase();
        if (!desc.includes(nf)) return false;
      }
      if (brandSet.size > 0 && !brandSet.has(p.brand)) return false;
      if (onSaleFilter && !isProductOnSale(p)) return false;
      return true;
    };

    const passTag = (p) =>
      tagSet.size === 0 ||
      (Array.isArray(p.tags) && p.tags.some((t) => tagSet.has(t)));

    const passPromo = (p) => {
      if (promoSet.size === 0) return true;
      const map = p.attributes && p.attributes.promo;
      if (!map) return false;
      return Object.entries(map).some(([parentId, childId]) => {
        if (promoSet.has(Number(parentId))) return true;
        if (childId && promoSet.has(childId)) return true;
        return false;
      });
    };

    const passInter = (p) => {
      if (interSet.size === 0) return true;
      const types = getProductInteractivityTypes(p);
      for (const t of interSet) {
        if (types.has(t)) return true;
      }
      return false;
    };

    // Each "baseExcept*" is the set of products that pass all filters except
    // the one of the group we're counting for. This gives counts in coherent
    // "if I picked X alone within its group" semantics.
    const baseExceptTag = products.filter(
      (p) => passCategoryNameBrandSale(p) && passPromo(p) && passInter(p)
    );
    const baseExceptPromo = products.filter(
      (p) => passCategoryNameBrandSale(p) && passTag(p) && passInter(p)
    );
    const baseExceptInter = products.filter(
      (p) => passCategoryNameBrandSale(p) && passTag(p) && passPromo(p)
    );

    const tagsCount = new Map();
    (this.state.tags || []).forEach((t) => {
      let n = 0;
      for (let i = 0; i < baseExceptTag.length; i++) {
        const p = baseExceptTag[i];
        if (Array.isArray(p.tags) && p.tags.includes(t.id)) n++;
      }
      tagsCount.set(t.id, n);
    });

    const promosCount = new Map();
    (this.state.promos || []).forEach((promo) => {
      let n = 0;
      for (let i = 0; i < baseExceptPromo.length; i++) {
        const p = baseExceptPromo[i];
        const map = p.attributes && p.attributes.promo;
        if (!map) continue;
        const match = Object.entries(map).some(([parentId, childId]) => {
          if (Number(parentId) === promo.id) return true;
          if (childId && childId === promo.id) return true;
          return false;
        });
        if (match) n++;
      }
      promosCount.set(promo.id, n);
    });

    const interCount = new Map();
    (this.interactivityTypes || []).forEach((it) => {
      let n = 0;
      for (let i = 0; i < baseExceptInter.length; i++) {
        if (getProductInteractivityTypes(baseExceptInter[i]).has(it.type)) n++;
      }
      interCount.set(it.type, n);
    });

    return { tagsCount, promosCount, interCount };
  };

  getGroupsForCurrentView = () => {
    const {
      categoryFilter,
      nameFilter,
      selectedTags,
      selectedPromos,
      selectedBrands,
      onSaleFilter,
      selectedInteractivities,
    } = this.state;
    const nf = (nameFilter || "").trim().toLowerCase();
    const matchName = (p) =>
      !nf || String(p.description || "").toLowerCase().includes(nf);

    const tagSet = selectedTags || new Set();
    const promoSet = selectedPromos || new Set();
    const brandSet = selectedBrands || new Set();

    const matchTags = (p) =>
      tagSet.size === 0
        ? true
        : Array.isArray(p.tags) && p.tags.some((t) => tagSet.has(t));
    const matchPromos = (p) => {
      if (promoSet.size === 0) return true;
      const promoMap = p.attributes && p.attributes.promo;
      if (!promoMap) return false;
      return Object.entries(promoMap).some(([parentId, childId]) => {
        if (promoSet.has(Number(parentId))) return true;
        if (childId && promoSet.has(childId)) return true;
        return false;
      });
    };
    const matchBrands = (p) =>
      brandSet.size === 0 ? true : brandSet.has(p.brand);
    const matchOnSale = (p) => (onSaleFilter ? isProductOnSale(p) : true);
    const interSet = selectedInteractivities || new Set();
    const matchInteractivities = (p) => {
      if (interSet.size === 0) return true;
      const types = getProductInteractivityTypes(p);
      for (const t of interSet) {
        if (types.has(t)) return true;
      }
      return false;
    };

    const cats =
      categoryFilter !== ""
        ? (this.allCategoriesMobile || []).filter(
            (c) => c.name === categoryFilter
          )
        : this.allCategoriesMobile || [];

    const groups = [];
    cats.forEach((c) => {
      const products = (this.productsByCategory[c.name] || [])
        .filter((el) => !el.dynamic_info)
        .filter(
          (i) => i.markers && i.markers.filter((m) => m.type === "plus").length > 0
        )
        .filter((el) => el.skul !== undefined)
        .filter(matchName)
        .filter(matchTags)
        .filter(matchPromos)
        .filter(matchBrands)
        .filter(matchOnSale)
        .filter(matchInteractivities);
      if (products.length > 0) {
        groups.push({
          categoryName: c.name,
          categoryLogo: c.logo,
          products,
        });
      }
    });
    return groups;
  };

  /**
   * Compute the flat list (limited by this.state.items) and re-build the
   * groups to render only the currently-loaded products.
   *
   * Returns: { groups, total, rendered }
   */
  getRenderedGroups = () => {
    const fullGroups = this.getGroupsForCurrentView();
    const limit = this.state.items || 0;
    const total = fullGroups.reduce((acc, g) => acc + g.products.length, 0);

    const rendered = [];
    let remaining = limit;
    for (let i = 0; i < fullGroups.length; i++) {
      if (remaining <= 0) break;
      const g = fullGroups[i];
      const slice = g.products.slice(0, remaining);
      remaining -= slice.length;
      if (slice.length) {
        rendered.push({
          categoryName: g.categoryName,
          categoryLogo: g.categoryLogo,
          products: slice,
        });
      }
    }
    const renderedCount = rendered.reduce((acc, g) => acc + g.products.length, 0);
    return { groups: rendered, total, rendered: renderedCount };
  };

  // ---- Step 4: filter persistence (sessionStorage) ----

  getStorageKey = () => {
    const leafletId =
      serverResponse.leaflet && serverResponse.leaflet.id != null
        ? serverResponse.leaflet.id
        : "_";
    return `pf:filters:${leafletId}`;
  };

  saveFiltersToSession = () => {
    try {
      const payload = {
        v: 1,
        leafletId: serverResponse.leaflet && serverResponse.leaflet.id,
        categoryFilter: this.state.categoryFilter || "",
        selectedTags: Array.from(this.state.selectedTags),
        selectedPromos: Array.from(this.state.selectedPromos),
        selectedBrands: Array.from(this.state.selectedBrands),
        selectedInteractivities: Array.from(
          this.state.selectedInteractivities || []
        ),
        nameFilter: this.state.nameFilter || "",
        onSaleFilter: Boolean(this.state.onSaleFilter),
        savedAt: Date.now(),
      };
      sessionStorage.setItem(this.getStorageKey(), JSON.stringify(payload));
    } catch (e) {
      /* quota-exceeded or unavailable storage — silently ignore */
    }
  };

  restoreFiltersFromSession = () => {
    let raw = null;
    try {
      raw = sessionStorage.getItem(this.getStorageKey());
    } catch (e) {
      return;
    }
    if (!raw) return;
    let p;
    try {
      p = JSON.parse(raw);
    } catch (e) {
      try {
        sessionStorage.removeItem(this.getStorageKey());
      } catch (e2) {
        /* no-op */
      }
      return;
    }
    if (
      !p ||
      p.v !== 1 ||
      p.leafletId !== (serverResponse.leaflet && serverResponse.leaflet.id)
    ) {
      return;
    }

    // Drop ids/brands that are no longer present in the current dataset.
    const validTagIds = new Set((this.state.tags || []).map((t) => t.id));
    const validPromoIds = new Set((this.state.promos || []).map((pp) => pp.id));
    const validBrands = new Set(
      (this.brandsList || []).map((b) => b.name)
    );

    const selectedTags = new Set(
      (Array.isArray(p.selectedTags) ? p.selectedTags : []).filter((id) =>
        validTagIds.has(id)
      )
    );
    const selectedPromos = new Set(
      (Array.isArray(p.selectedPromos) ? p.selectedPromos : []).filter((id) =>
        validPromoIds.has(id)
      )
    );
    const selectedBrands = new Set(
      (Array.isArray(p.selectedBrands) ? p.selectedBrands : []).filter((n) =>
        validBrands.has(n)
      )
    );
    const validInter = new Set(
      (this.interactivityTypes || []).map((i) => i.type)
    );
    const selectedInteractivities = new Set(
      (Array.isArray(p.selectedInteractivities)
        ? p.selectedInteractivities
        : []
      ).filter((t) => validInter.has(t))
    );

    const restoredCategory =
      typeof p.categoryFilter === "string" ? p.categoryFilter : "";
    // If the saved category no longer exists in the current leaflet, drop it.
    const categoryStillExists =
      !restoredCategory ||
      (this.allCategoriesMobile || []).some((c) => c.name === restoredCategory);

    const anyExtraFilter =
      selectedTags.size > 0 ||
      selectedPromos.size > 0 ||
      selectedBrands.size > 0 ||
      selectedInteractivities.size > 0 ||
      Boolean(p.onSaleFilter);
    const nextCategory = categoryStillExists ? restoredCategory : "";
    const nextName = typeof p.nameFilter === "string" ? p.nameFilter : "";

    this.setState(
      {
        categoryFilter: nextCategory,
        selectedTags,
        selectedPromos,
        selectedBrands,
        selectedInteractivities,
        nameFilter: nextName,
        onSaleFilter: Boolean(p.onSaleFilter),
        items: 0,
        itemsToRender: [],
        // Drive desktop conditional renderers consistently with how the
        // bottom-sheet "apply" handler does it.
        tagsItemRender: anyExtraFilter,
        promoItemRender: false,
        itemsRender: !anyExtraFilter && Boolean(nextCategory),
        isFirstTime: false,
      },
      () => this.updateProducts()
    );
  };

  // ---- Step 4: sticky stack auto-hide on scroll down ----

  handleStickyAutoHide = () => {
    this._scrollRaf = null;
    const el = document.querySelector("#scrollable-div");
    if (!el) return;
    const y = el.scrollTop;
    const delta = y - this._lastScrollY;
    const SHOW_MIN = 50;
    const HIDE_DELTA = 10;
    const SHOW_DELTA = 4;
    if (y < SHOW_MIN) {
      if (this.state.stickyRowHidden) this.setState({ stickyRowHidden: false });
    } else if (delta > HIDE_DELTA && !this.state.stickyRowHidden) {
      this.setState({ stickyRowHidden: true });
    } else if (delta < -SHOW_DELTA && this.state.stickyRowHidden) {
      this.setState({ stickyRowHidden: false });
    }
    this._lastScrollY = y;
  };

  // ---- Step 4: single-filter removal handlers (mobile active chips) ----

  // Single-filter removers — route through applyFilterToggle so the desktop
  // conditional render flags (tagsItemRender / itemsRender) get recomputed.
  // Without this, removing the last tag/promo/etc would leave tagsItemRender
  // stuck on true and the "Tutti i prodotti" grouped view never reappears.
  removeSingleTag = (id) => {
    if (this.state.selectedTags && this.state.selectedTags.has(id)) {
      this.applyFilterToggle("tags", id);
    }
  };

  removeSinglePromo = (id) => {
    if (this.state.selectedPromos && this.state.selectedPromos.has(id)) {
      this.applyFilterToggle("promos", id);
    }
  };

  removeSingleBrand = (name) => {
    if (this.state.selectedBrands && this.state.selectedBrands.has(name)) {
      this.applyFilterToggle("brands", name);
    }
  };

  removeNameFilter = () => {
    if (!this.state.nameFilter) return;
    // Same shape used by applyFilterToggle so flags get recomputed via
    // handleApplyFilters. nameFilter is reset via setState first.
    this.setState({ nameFilter: "" }, () => {
      this.handleApplyFilters({
        tags: new Set(this.state.selectedTags),
        promos: new Set(this.state.selectedPromos),
        brands: new Set(this.state.selectedBrands),
        onSale: this.state.onSaleFilter,
        interactivities: new Set(this.state.selectedInteractivities),
      });
    });
  };

  removeCategoryFilter = () => {
    this.handleSelectCategoryChip(null);
  };

  handleToggleOnSale = () => {
    this.applyFilterToggle("onSale");
  };

  toggleAccordion = (key) => {
    this.setState((prev) => ({
      accordionOpen: {
        ...prev.accordionOpen,
        [key]: !prev.accordionOpen[key],
      },
    }));
  };

  toggleSetMember = (stateKey, value) => {
    this.setState(
      (prev) => {
        const s = new Set(prev[stateKey] || new Set());
        if (s.has(value)) s.delete(value);
        else s.add(value);
        return { [stateKey]: s };
      },
      () => this.updateProducts()
    );
  };

  // Toggle a single value from a multi-select filter (tag/promo/inter/brand)
  // and re-apply the full filter set through the same pipeline used by the
  // mobile bottom-sheet. Keeps desktop and mobile filter behavior aligned.
  applyFilterToggle = (group, value) => {
    const next = {
      tags: new Set(this.state.selectedTags),
      promos: new Set(this.state.selectedPromos),
      brands: new Set(this.state.selectedBrands),
      onSale: this.state.onSaleFilter,
      interactivities: new Set(this.state.selectedInteractivities),
    };
    if (group === "onSale") {
      next.onSale = !next.onSale;
    } else if (next[group] instanceof Set) {
      if (next[group].has(value)) next[group].delete(value);
      else next[group].add(value);
    }
    this.handleApplyFilters(next);
  };

  removeSingleInteractivity = (type) => {
    if (
      this.state.selectedInteractivities &&
      this.state.selectedInteractivities.has(type)
    ) {
      this.applyFilterToggle("interactivities", type);
    }
  };

  removeOnSaleFilter = () => {
    if (!this.state.onSaleFilter) return;
    this.applyFilterToggle("onSale");
  };

  renderMobileProduct = (product, idx) => {
    return (
      <div
        key={`mp_${product.item_id || product.id}_${idx}`}
        className="h-full product-item-block-wrap"
      >
        <Product
          fromProducts={true}
          elementIndex={idx}
          dynamic_price={product.dynamic_price}
          dynamic_info={product.dynamic_info}
          info={getCustomActions().getInteractivity(product.item_id)}
          groceryList={this.props.groceryList}
        />
      </div>
    );
  };

  render() {
    const {
      nameFilter,
      //  subCategoryArr,
      // showScrollUp
    } = this.state;

    let subcategories = [];
    if (this.state.categoryFilter !== "") {
      serverResponse.leaflet.categories.map((element) => {
        if (element.category_name === this.state.categoryFilter) {
          subcategories = element.subcategories;
        }
        return false;
      });
    }

    let brandInput = "";
    let underpriceInput = "";
    let amostOneCustomCheckbox = false;

    const filtri = (
      <>
        {(() => {
          const catCounts = this.getCategoryCounts();
          const totalCount = catCounts.total;
          const noFiltersApplied =
            this.state.nameFilter === "" &&
            this.state.onSaleFilter === false &&
            this.state.categoryFilter === "" &&
            this.state.subCategoryFilter === "" &&
            (!this.state.selectedTags ||
              this.state.selectedTags.size === 0) &&
            (!this.state.selectedPromos ||
              this.state.selectedPromos.size === 0) &&
            (!this.state.selectedBrands ||
              this.state.selectedBrands.size === 0) &&
            (!this.state.selectedInteractivities ||
              this.state.selectedInteractivities.size === 0);
          const offerteLabel =
            (language[defaultLanguage] &&
              language[defaultLanguage].offerte) ||
            "Offerte";
          const interLabel =
            (language[defaultLanguage] &&
              language[defaultLanguage].interattivita_section) ||
            "Interattività";
          const categorieLabel =
            (language[defaultLanguage] &&
              language[defaultLanguage].categorie) ||
            "Categorie";
          const tuttiLabel =
            (language[defaultLanguage] && language[defaultLanguage].tutti) ||
            "Tutti";
          const filtriLabel =
            (language[defaultLanguage] && language[defaultLanguage].filtri) ||
            "Filtri";
          return (
            <div className="row ma-0 d-none d-sm-block">
              <div className="roe-card-body">
                <div
                  className={`sidebarMenuBlock pf-sidebar ${
                    !("left_bar" in serverResponse.config) ||
                    (!serverResponse.config.left_bar && "filterleft")
                  }`}
                >
                  <div className="theme-brand text-center">
                    <img
                      className="img-fluid pf-sidebar-logo"
                      src={serverResponse.config.logo_full}
                      alt=""
                    />
                  </div>

                  <div className="sidebarMenuBlock__item">
                    <InputGroup>
                      <Search />
                      <Input
                        placeholder={language[defaultLanguage].prodotto}
                        id="product_"
                        onChange={this.handleChangeName}
                        value={nameFilter}
                      />
                    </InputGroup>
                  </div>

                  {/* Chip filtri attivi — sotto la search, prima della sezione FILTRI */}
                  <div className="pf-sidebar-active-chips">
                    <ActiveFiltersRow
                      categoryFilter={this.state.categoryFilter}
                      tags={this.state.tags}
                      promos={this.state.promos}
                      brands={this.brandsList || []}
                      nameFilter={this.state.nameFilter}
                      selectedTags={this.state.selectedTags}
                      selectedPromos={this.state.selectedPromos}
                      selectedBrands={this.state.selectedBrands}
                      onRemoveCategory={this.removeCategoryFilter}
                      onRemoveTag={this.removeSingleTag}
                      onRemovePromo={this.removeSinglePromo}
                      onRemoveBrand={this.removeSingleBrand}
                      onRemoveName={this.removeNameFilter}
                      onSaleActive={this.state.onSaleFilter}
                      onRemoveOnSale={this.removeOnSaleFilter}
                      selectedInteractivities={this.state.selectedInteractivities}
                      onRemoveInteractivity={this.removeSingleInteractivity}
                    />
                  </div>

                  {(() => {
                    const hasTagSection =
                      Array.isArray(this.state.tags) &&
                      this.state.tags.length > 0;
                    const hasPromoSection =
                      Array.isArray(this.state.promos) &&
                      this.state.promos.length > 0;
                    const showFiltersSection =
                      this.showOnSaleFilter ||
                      hasTagSection ||
                      hasPromoSection ||
                      this.showInteractivityFilter;
                    if (!showFiltersSection) return null;

                    const ao = this.state.accordionOpen || {};

                    const renderSwitchRow = ({
                      key,
                      label,
                      image,
                      iconNode,
                      count,
                      checked,
                      onToggle,
                    }) => (
                      <button
                        key={key}
                        type="button"
                        className={`pf-sidebar-row pf-sidebar-filter-row ${
                          checked ? "pf-sidebar-row--checked" : ""
                        }`}
                        role="switch"
                        aria-checked={!!checked}
                        onClick={onToggle}
                      >
                        {image && (
                          <img
                            className="pf-sidebar-row__logo"
                            src={image}
                            alt=""
                            aria-hidden="true"
                          />
                        )}
                        {!image && iconNode && (
                          <span
                            className="pf-sidebar-row__icon"
                            aria-hidden="true"
                          >
                            {iconNode}
                          </span>
                        )}
                        <span className="pf-sidebar-row__label">{label}</span>
                        {typeof count === "number" && (
                          <span className="pf-sidebar-row__count">
                            ({count})
                          </span>
                        )}
                        <span
                          className={`pf-switch pf-switch--sm ${
                            checked ? "pf-switch--on" : ""
                          }`}
                          aria-hidden="true"
                        >
                          <span className="pf-switch__track">
                            <span className="pf-switch__thumb" />
                          </span>
                        </span>
                      </button>
                    );

                    const renderAccordion = ({
                      key,
                      label,
                      selectedCount,
                      open,
                      children,
                    }) => (
                      <div className="pf-sidebar-accordion">
                        <button
                          type="button"
                          className="pf-sidebar-accordion__header"
                          aria-expanded={open}
                          onClick={() => this.toggleAccordion(key)}
                        >
                          <span className="pf-sidebar-accordion__title">
                            {label}
                          </span>
                          {selectedCount > 0 && (
                            <span className="pf-sidebar-accordion__badge">
                              {selectedCount}
                            </span>
                          )}
                          <span
                            className={`pf-sidebar-accordion__chevron ${
                              open
                                ? "pf-sidebar-accordion__chevron--open"
                                : ""
                            }`}
                            aria-hidden="true"
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <polyline points="6 9 12 15 18 9" />
                            </svg>
                          </span>
                        </button>
                        {open && (
                          <div className="pf-sidebar-accordion__body">
                            {children}
                          </div>
                        )}
                      </div>
                    );

                    const dynCounts = this.getDynamicFilterCounts();

                    return (
                      <div className="pf-sidebar-section">
                        <div className="pf-sidebar-section__label pf-sidebar-section__label--with-action">
                          <span>{filtriLabel}</span>
                          <button
                            type="button"
                            className="pf-sidebar-section__action"
                            onClick={() => this.resetFilters()}
                            disabled={noFiltersApplied}
                          >
                            {language[defaultLanguage].reset_filtri}
                          </button>
                        </div>

                        {this.showOnSaleFilter &&
                          renderSwitchRow({
                            key: "onsale",
                            label: offerteLabel,
                            checked: !!this.state.onSaleFilter,
                            onToggle: () => this.applyFilterToggle("onSale"),
                          })}

                        {hasTagSection &&
                          renderAccordion({
                            key: "tag",
                            label:
                              (language[defaultLanguage] &&
                                language[defaultLanguage].tag_section) ||
                              "Tag",
                            selectedCount: this.state.selectedTags.size,
                            open: !!ao.tag,
                            children: this.state.tags.map((t) =>
                              renderSwitchRow({
                                key: `tag_${t.id}`,
                                label: t.nome,
                                image: t.immagine,
                                count: dynCounts.tagsCount.get(t.id) || 0,
                                checked: this.state.selectedTags.has(t.id),
                                onToggle: () =>
                                  this.applyFilterToggle("tags", t.id),
                              })
                            ),
                          })}

                        {hasPromoSection &&
                          renderAccordion({
                            key: "promo",
                            label:
                              (language[defaultLanguage] &&
                                language[defaultLanguage].promo_section) ||
                              "Promo",
                            selectedCount: this.state.selectedPromos.size,
                            open: !!ao.promo,
                            children: this.state.promos.map((p) =>
                              renderSwitchRow({
                                key: `promo_${p.id}`,
                                label: p.nome,
                                image: p.img,
                                count: dynCounts.promosCount.get(p.id) || 0,
                                checked: this.state.selectedPromos.has(p.id),
                                onToggle: () =>
                                  this.applyFilterToggle("promos", p.id),
                              })
                            ),
                          })}

                        {this.showInteractivityFilter &&
                          renderAccordion({
                            key: "interactivity",
                            label: interLabel,
                            selectedCount: (
                              this.state.selectedInteractivities || new Set()
                            ).size,
                            open: !!ao.interactivity,
                            children: this.interactivityTypes.map((it) => {
                              const labelKey =
                                INTERACTIVITY_TYPE_TO_LABEL_KEY[it.type] ||
                                it.type;
                              const itLabel =
                                (language[defaultLanguage] &&
                                  language[defaultLanguage][labelKey]) ||
                                it.type;
                              const iconEntry = iconsObj[it.type];
                              return renderSwitchRow({
                                key: `int_${it.type}`,
                                label: itLabel,
                                iconNode:
                                  iconEntry && iconEntry.component,
                                count:
                                  dynCounts.interCount.get(it.type) || 0,
                                checked: (
                                  this.state.selectedInteractivities ||
                                  new Set()
                                ).has(it.type),
                                onToggle: () =>
                                  this.applyFilterToggle(
                                    "interactivities",
                                    it.type
                                  ),
                              });
                            }),
                          })}
                      </div>
                    );
                  })()}

                  <div className="pf-sidebar-section">
                    <div className="pf-sidebar-section__label">
                      {categorieLabel}
                    </div>
                    <button
                      type="button"
                      className={`pf-sidebar-row pf-sidebar-cat-row ${
                        this.state.categoryFilter === ""
                          ? "pf-sidebar-row--active"
                          : ""
                      }`}
                      onClick={() => this.handleSelectCategoryChip(null)}
                    >
                      <span className="pf-sidebar-row__label">
                        {tuttiLabel}
                      </span>
                      <span className="pf-sidebar-row__count">
                        ({totalCount})
                      </span>
                    </button>
                    {serverResponse.leaflet.categories.map((element, key) => {
                      const catEntry = catCounts.byCategory.get(
                        element.category_name
                      );
                      const catCount = catEntry ? catEntry.total : 0;
                      const subs = element.subcategories || [];
                      const hasSubs = subs.length > 0;
                      const isActive =
                        this.state.categoryFilter === element.category_name;
                      const isExpanded =
                        this.state.activeChevronCategory ===
                          element.category_name && hasSubs;
                      return (
                        <div
                          key={`${element.category_name}_${key}`}
                          className="pf-sidebar-cat"
                        >
                          <button
                            type="button"
                            className={`pf-sidebar-row pf-sidebar-cat-row ${
                              isActive ? "pf-sidebar-row--active" : ""
                            }`}
                            onClick={() => {
                              this.handleChangeCategory(
                                element.category_name,
                                element.category_logo
                              );
                              if (hasSubs) {
                                this.classChangeClick(element.category_name);
                              }
                            }}
                            aria-expanded={hasSubs ? isExpanded : undefined}
                          >
                            {element.category_logo &&
                              this.state.shouldShowLogos && (
                                <img
                                  className="pf-sidebar-row__logo"
                                  src={element.category_logo}
                                  alt=""
                                  aria-hidden="true"
                                />
                              )}
                            <span className="pf-sidebar-row__label">
                              {element.category_name}
                            </span>
                            <span className="pf-sidebar-row__count">
                              ({catCount})
                            </span>
                            {hasSubs && (
                              <span
                                className={`pf-sidebar-row__chevron ${
                                  isExpanded
                                    ? "pf-sidebar-row__chevron--open"
                                    : ""
                                }`}
                                aria-hidden="true"
                              >
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <polyline points="6 9 12 15 18 9" />
                                </svg>
                              </span>
                            )}
                          </button>
                          {isExpanded &&
                            subs.map((subc, sk) => {
                              const subCount =
                                catEntry &&
                                catEntry.subs.has(subc)
                                  ? catEntry.subs.get(subc)
                                  : 0;
                              const subActive =
                                this.state.subCategoryFilter === subc;
                              return (
                                <button
                                  type="button"
                                  key={`${subc}_${sk}`}
                                  className={`pf-sidebar-row pf-sidebar-subcat-row ${
                                    subActive
                                      ? "pf-sidebar-row--active"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.handleChangeSubCategory(subc)
                                  }
                                >
                                  <span className="pf-sidebar-row__label">
                                    {subc}
                                  </span>
                                  <span className="pf-sidebar-row__count">
                                    ({subCount})
                                  </span>
                                </button>
                              );
                            })}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          );
        })()}

        {/* Mobile sticky chips row + active filters row (Step 1 + 4) */}
        <div className="d-block d-sm-none">
          <div
            className={
              "pf-sticky-stack" +
              (this.state.stickyRowHidden ? " pf-sticky-stack--hidden" : "")
            }
          >
            <CategoryChipsRow
              categories={this.allCategoriesMobile || []}
              selectedCategoryName={this.state.categoryFilter || ""}
              onSelect={this.handleSelectCategoryChip}
              onFilterButtonClick={this.handleFilterButtonClick}
              filterCount={
                this.state.selectedTags.size +
                this.state.selectedPromos.size +
                this.state.selectedBrands.size +
                (this.state.onSaleFilter ? 1 : 0) +
                (this.state.selectedInteractivities
                  ? this.state.selectedInteractivities.size
                  : 0)
              }
              hasAnyFilter={
                (this.state.tags && this.state.tags.length > 0) ||
                (this.state.promos && this.state.promos.length > 0) ||
                (this.brandsList && this.brandsList.length > 0) ||
                this.showOnSaleFilter ||
                this.showInteractivityFilter
              }
            />
            <ActiveFiltersRow
              categoryFilter={this.state.categoryFilter}
              tags={this.state.tags}
              promos={this.state.promos}
              brands={this.brandsList || []}
              nameFilter={this.state.nameFilter}
              selectedTags={this.state.selectedTags}
              selectedPromos={this.state.selectedPromos}
              selectedBrands={this.state.selectedBrands}
              onRemoveCategory={this.removeCategoryFilter}
              onRemoveTag={this.removeSingleTag}
              onRemovePromo={this.removeSinglePromo}
              onRemoveBrand={this.removeSingleBrand}
              onRemoveName={this.removeNameFilter}
              onSaleActive={this.state.onSaleFilter}
              onRemoveOnSale={this.removeOnSaleFilter}
              selectedInteractivities={this.state.selectedInteractivities}
              onRemoveInteractivity={this.removeSingleInteractivity}
            />
          </div>
        </div>
      </>
    );

    return (
      <div ref={this.myRef}>
        {filtri}

        <div
          id="scrollable-div"
          className="container-fluid productCategory-content px-0"
          style={{
            // overflow: "auto",

            marginTop:
              serverResponse.config.category_banner === "" ||
              !serverResponse.config.category_banner
                ? "0px"
                : "px",
          }}
          onScroll={(e) => {
            if (e.target.scrollTop > 300) {
              if (!this.state.showScrollUp) {
                this.setState({
                  showScrollUp: true,
                });
              }
            } else {
              if (this.state.showScrollUp) {
                this.setState({
                  showScrollUp: false,
                });
              }
            }
          }}
        >
          {/* Bottom-sheet filtri (mobile) — replaces legacy OffCanvas */}
          <div className="d-block d-sm-none">
            <FiltersBottomSheet
              open={this.state.bottomSheetOpen}
              onClose={this.handleCloseBottomSheet}
              onApply={this.handleApplyFilters}
              initialFilters={{
                tags: this.state.selectedTags,
                promos: this.state.selectedPromos,
                brands: this.state.selectedBrands,
                onSale: this.state.onSaleFilter,
                interactivities: this.state.selectedInteractivities,
              }}
              tags={this.state.tags}
              promos={this.state.promos}
              brands={this.brandsList || []}
              hasOnSale={this.showOnSaleFilter}
              interactivities={
                this.showInteractivityFilter ? this.interactivityTypes : []
              }
              products={this.state.products}
              categoryFilter={this.state.categoryFilter}
              nameFilter={this.state.nameFilter}
            />
          </div>

          {!this.state.itemsRender &&
            !this.state.tagsItemRender &&
            !this.state.promoItemRender &&
            serverResponse.config.category_banner && (
              <div className="col-sm-12 d-none d-sm-flex text-center">
                <img
                  className="product-banner-block"
                  alt="banner"
                  onClick={openBanner}
                  src={serverResponse.config.category_banner}
                />
              </div>
            )}
          {/* Legacy desktop tag/promo slider rimosso (Step 8).
              Le chip filtri attivi sono ora dentro la sidebar (Step 8b). */}

          {!this.state.itemsRender &&
            !this.state.tagsItemRender &&
            !this.state.promoItemRender &&
            serverResponse.config.category_banner_mobile && (
              <div className="col-sm-12 d-flex d-sm-none">
                <img
                  className="product-banner-block"
                  alt="banner"
                  onClick={this.openBanner}
                  src={serverResponse.config.category_banner_mobile}
                  style={{ cursor: "pointer", maxWidth: "100%" }}
                />
              </div>
            )}
          {serverResponse.config.adsense && <Adsense />}

          {/* DESKTOP rendering (unchanged behavior, hidden on mobile) */}
          <div
            id="scroller"
            className="filtered-products justify-content-center d-none d-sm-block"
          >
            {/* Default desktop view (no filters): all products grouped by
                category, mirroring the mobile grouped-grid behavior but with
                the desktop column sizing. */}
            {!this.state.tagsItemRender &&
              !this.state.promoItemRender &&
              !this.state.itemsRender &&
              (() => {
                const { groups } = this.getRenderedGroups();
                if (!groups || groups.length === 0) return null;
                const L = (key, fallback) =>
                  (language[defaultLanguage] &&
                    language[defaultLanguage][key]) ||
                  fallback;
                const nf = (this.state.nameFilter || "").trim();
                const anyExtraFilter =
                  (this.state.selectedTags &&
                    this.state.selectedTags.size > 0) ||
                  (this.state.selectedPromos &&
                    this.state.selectedPromos.size > 0) ||
                  (this.state.selectedBrands &&
                    this.state.selectedBrands.size > 0) ||
                  (this.state.selectedInteractivities &&
                    this.state.selectedInteractivities.size > 0) ||
                  this.state.onSaleFilter === true;
                let headingText = L("tutti_i_prodotti", "Tutti i prodotti");
                if (nf) {
                  headingText = L(
                    "risultati_per",
                    "Risultati per «{q}»"
                  ).replace("{q}", nf);
                } else if (anyExtraFilter) {
                  headingText = L("prodotti_filtrati", "Prodotti filtrati");
                }
                return (
                  <div className="categories-static w-100">
                    {this.state.categoryFilter === "" && (
                      <h1 className="pf-all-products-heading">
                        {headingText}
                      </h1>
                    )}
                    {groups.map((g) => (
                      <div key={g.categoryName} className="mb-4">
                        <h2>
                          <span>
                            <span>
                              {g.categoryLogo &&
                                this.state.shouldShowLogos && (
                                  <img
                                    src={g.categoryLogo}
                                    alt=""
                                    style={{
                                      width: "30px",
                                      aspectRatio: "1",
                                    }}
                                  />
                                )}
                            </span>
                            <span className="ms-2">{g.categoryName}</span>
                          </span>
                        </h2>
                        <div className="categories-static-inner p-0">
                          {g.products.map((product, k) => (
                            <div
                              key={`${product.id}_${k}`}
                              className="col-6 col-sm-6 col-lg-6 col-xl-3 col-xxxl-2 h-full product-item-block-wrap"
                            >
                              <Product
                                fromProducts={true}
                                info={product}
                                groceryList={this.props.groceryList}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })()}
            {!this.state.tagsItemRender &&
              !this.state.promoItemRender &&
              this.state.itemsRender && (
                <>
                  {/* L'h2 deve stare FUORI dal grid: altrimenti occupa la
                      prima cella e le card si dispongono dopo, scompaginando
                      il layout. */}
                  <div className="categories-static">
                    <h2>
                      <span>
                        <span>
                          {this.state.categoryLogo && (
                            <img
                              src={this.state.categoryLogo}
                              alt=""
                              style={{ width: "30px", aspectRatio: "1" }}
                            />
                          )}
                        </span>
                        <span className="ms-2">
                          {this.state.categoryFilter}{" "}
                          {this.state.subCategoryFilter
                            ? ` - ${this.state.subCategoryFilter}`
                            : null}
                        </span>
                      </span>
                    </h2>
                  </div>
                  <div className="categories-static-inner p-0">
                    {this.state.itemsToRender.map((element, key) => (
                      <div
                        key={`${element.id}_${key}`}
                        className="col-6 col-sm-6 col-lg-6 col-xl-3 col-xxxl-2 h-full product-item-block-wrap"
                      >
                        <Product
                          fromProducts={true}
                          elementIndex={key}
                          dynamic_price={element.dynamic_price}
                          dynamic_info={element.dynamic_info}
                          info={getCustomActions().getInteractivity(
                            element.item_id
                          )}
                          groceryList={this.props.groceryList}
                        />
                      </div>
                    ))}
                  </div>
                </>
              )}
            {this.state.tagsItemRender && (() => {
              const nf = (this.state.nameFilter || "").trim();
              let heading =
                (language[defaultLanguage] &&
                  language[defaultLanguage].prodotti_filtrati) ||
                "Prodotti filtrati";
              if (nf) {
                heading = (
                  (language[defaultLanguage] &&
                    language[defaultLanguage].risultati_per) ||
                  "Risultati per «{q}»"
                ).replace("{q}", nf);
              }
              return (
                <>
                  <h1 className="pf-all-products-heading">{heading}</h1>
                  <div className="categories-static-inner p-0">
                    {this.state.products
                      .filter(this.productFilter)
                      .map((product, key) => (
                        <div
                          key={`${product.id}_${key}`}
                          className="col-6 col-sm-6 col-lg-6 col-xl-3 col-xxxl-2 h-full product-item-block-wrap"
                        >
                          <Product
                            fromProducts={true}
                            info={product}
                            groceryList={this.props.groceryList}
                          />
                        </div>
                      ))}
                  </div>
                </>
              );
            })()}
            {this.state.promoItemRender && (
              <div className="categories-static-inner p-0">
                {this.state.products
                  .filter(this.productFilter)
                  .map((product, key) => {
                    return (
                      <div
                        key={`${product.id}_${key}`}
                        className="col-6 col-sm-6 col-lg-6 col-xl-3 col-xxxl-2 h-full product-item-block-wrap"
                      >
                        <Product
                          fromProducts={true}
                          info={product}
                          groceryList={this.props.groceryList}
                        />
                      </div>
                    );
                  })}
              </div>
            )}
          </div>

          {/* MOBILE rendering: grouped grid + loading/empty/end-marker */}
          {(() => {
            const { groups, total, rendered } = this.getRenderedGroups();
            const shouldShowLogos = this.state.shouldShowLogos;
            const mostraTuttiLabel =
              (language[defaultLanguage] &&
                (language[defaultLanguage].mostra_tutti_reset ||
                  language[defaultLanguage].mostra_tutti)) ||
              "Mostra tutti";
            const noProductsTitle =
              (language[defaultLanguage] &&
                language[defaultLanguage]
                  .nessun_prodotto_trovato_per_i_parametri_di_ricerca_inseriti) ||
              "Nessun prodotto trovato";
            const noProductsHint =
              (language[defaultLanguage] &&
                language[defaultLanguage].nessun_prodotto_hint) ||
              "";
            const caricamento =
              (language[defaultLanguage] &&
                language[defaultLanguage].caricamento) ||
              "Caricamento…";
            const haiVistoTutto =
              (language[defaultLanguage] &&
                language[defaultLanguage].hai_visto_tutto) ||
              "";

            const L = (key, fallback) =>
              (language[defaultLanguage] &&
                language[defaultLanguage][key]) ||
              fallback;
            const nfTrim = (this.state.nameFilter || "").trim();
            const anyExtraFilterMobile =
              (this.state.selectedTags &&
                this.state.selectedTags.size > 0) ||
              (this.state.selectedPromos &&
                this.state.selectedPromos.size > 0) ||
              (this.state.selectedBrands &&
                this.state.selectedBrands.size > 0) ||
              (this.state.selectedInteractivities &&
                this.state.selectedInteractivities.size > 0) ||
              this.state.onSaleFilter === true;
            let mobileHeadingText = L(
              "tutti_i_prodotti",
              "Tutti i prodotti"
            );
            if (nfTrim) {
              mobileHeadingText = L(
                "risultati_per",
                "Risultati per «{q}»"
              ).replace("{q}", nfTrim);
            } else if (anyExtraFilterMobile) {
              mobileHeadingText = L("prodotti_filtrati", "Prodotti filtrati");
            }
            const showAllHeading =
              rendered > 0 && this.state.categoryFilter === "";
            return (
              <div className="d-block d-sm-none">
                {showAllHeading && (
                  <h1 className="pf-all-products-heading pf-all-products-heading--mobile">
                    {mobileHeadingText}
                  </h1>
                )}
                {rendered > 0 && (
                  <ProductsGridGrouped
                    groups={groups}
                    renderProduct={this.renderMobileProduct}
                    showLogos={shouldShowLogos}
                  />
                )}

                {rendered === 0 && !this.state.isFirstTime && (
                  <div className="pf-empty" role="status">
                    <svg
                      className="pf-empty__icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <circle cx="11" cy="11" r="7" />
                      <line x1="21" y1="21" x2="16.65" y2="16.65" />
                      <line x1="8" y1="11" x2="14" y2="11" />
                    </svg>
                    <h3 className="pf-empty__title">{noProductsTitle}</h3>
                    {noProductsHint && (
                      <p className="pf-empty__hint">{noProductsHint}</p>
                    )}
                    <button
                      type="button"
                      className="pf-empty__btn"
                      onClick={() => this.handleSelectCategoryChip(null)}
                    >
                      {mostraTuttiLabel}
                    </button>
                  </div>
                )}

                {rendered > 0 && total > 0 && rendered < total && (
                  <div className="pf-loading" role="status" aria-live="polite">
                    {caricamento}
                  </div>
                )}

                {rendered > 0 && rendered === total && (
                  <div className="pf-end-marker" role="status">
                    {haiVistoTutto}
                  </div>
                )}
              </div>
            );
          })()}

          {/* Desktop empty state (preserves previous behavior) */}
          {this.state.itemsToRender.length === 0 && !this.state.isFirstTime && (
            <div
              className="col-12 custom-padding d-none d-sm-block"
              style={{ padding: "5px" }}
            >
              <h3 className="noProducts">
                {
                  language[defaultLanguage]
                    .nessun_prodotto_trovato_per_i_parametri_di_ricerca_inseriti
                }
              </h3>
            </div>
          )}
        </div>

        {/* <div
          className="scroll-up-btn"
          style={styles.buttonScrollUpBtn(
            showScrollUp ? "flex" : "none",
            "white"
          )}
          onClick={() => {
            if (isIE || isEdge) {
              document.getElementById("scrollable-div").scrollTop = 0;
            } else {
              document.getElementById("scrollable-div").scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
              });
            }
          }}
          id="arrowScrollTop"
        >
          <FontAwesomeIcon
            size="1x"
            style={styles.displayType(!showScrollUp && "none")}
            icon={faArrowUp}
          />
        </div> */}

        {/* <div
          onClick={() => {
            this.setState({
              sidebarFilterOpen: true,
            });
          }}
          className="filter-scroll-up d-flex d-lg-none shadow"
          style={styles.filterScrollUp(
            serverResponse.config.secondary_color,
            showScrollUp ? "10" : "10"
          )}
        >
          <FontAwesomeIcon
            onClick={() => {
              this.setState({
                sidebarFilterOpen: true,
              });
            }}
            size="1x"
            style={styles.displayType()}
            icon={faFilter}
          />
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // ...state.themeChanger
    groceryList: state.groceryList,
  };
};

export default connect(mapStateToProps, {
  getPricesAction,
  openInteractivityModal,
})(withLocation(withParams(CategoriesStatic)));
